import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@mui/material';

function StartupRowLoading({ id }) {
  return (
    <div key={id}>
      <div className='startup'>
        <div className='company_header' style={{ maxHeight: '40px' }}>
          <Skeleton animation='wave' width={45} height={65} />
          <div className='company_info'>
            <div className='company_info--left'>
              <Skeleton animation='wave' width={200} height={25} />
              <Skeleton animation='wave' width={130} height={18} />

            </div>
            <Skeleton animation='wave' width={24} height={24} variant='circular' />
          </div>
        </div>

        <div className='company_country'>
          <Skeleton animation='wave' width={150} height={18} />
        </div>
        <div className='company_description'>
          <Skeleton animation='wave' width='100%' height={15} />
          <Skeleton animation='wave' width='50%' height={15} />
        </div>
        <div className='company_keywords'>
          <Skeleton animation='wave' width={45} height={16} />
          <Skeleton animation='wave' width={70} height={16} />
        </div>
      </div>
    </div>
  );
}

StartupRowLoading.propTypes = {
  id: PropTypes.string.isRequired,
};

export default StartupRowLoading;
